import { iconsService } from '../../services/IconsService';

import React from 'react';

type IconItem = {
  title: string;
  onClick: () => void;
  name: string; // o el tipo que uses para identificar el icono
};

type Props = {
  icons?: any[];
};

export const IconBar: React.FC<Props> = ({ icons = [] }) => {
  const service = iconsService;

  return (
    <div className="flex w-full h-full bg-primary-ShadowPCP004 rounded-md justify-end items-center content-center">
      {icons.map((icon, i) => (
        <div
          key={i}
          onClick={icon.onClick}
          title={icon.title}
          className="flex w-4 h-4 justify-center content-center items-center text-white cursor-pointer">
          {service.getIcon(icon)}
        </div>
      ))}
    </div>
  );
};
